/* document.addEventListener("DOMContentLoaded", () => {

  const targetNode = document.querySelector('#cart-subtotal'); // Adjust the selector based on your DOM
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        //checkCartTotal();
      }
    });
  });

  // Start observing the cart subtotal
  if (targetNode) {
    observer.observe(targetNode, config);
  } else {
    console.error('Target node for MutationObserver not found!');
  }



    // Select the cart drawer element
    const cartDrawer = document.querySelector('.cart-drawer'); // Update selector as needed
    const body = document.body;

    // Function to add/remove class based on drawer state
    function toggleCartClass(isOpen) {
        if (isOpen) {
            body.classList.add('cart_drawer_opened');
        } else {
            body.classList.remove('cart_drawer_opened');
        }
    }

    // Event listener for opening the cart drawer
    document.querySelector('.open-cart-button').addEventListener('click', function () {
        toggleCartClass(true);
    });

    // Event listener for closing the cart drawer
    document.querySelector('.cart__drawer-header-close').addEventListener('click', function () {
        toggleCartClass(false);
    });


}); */

const strikeThroughPriceElements = document.querySelectorAll(".ctm-strike-through_price");

if (strikeThroughPriceElements.length > 0) {
    // Function to clean the text content
    const cleanTextContent = (element) => {
        if (element.textContent.startsWith("- ")) {
            element.textContent = element.textContent.replace(/^- /, '');
        }
    };


    strikeThroughPriceElements.forEach((element) => cleanTextContent(element));

    const observer = new MutationObserver(() => {
        document.querySelectorAll(".ctm-strike-through_price").forEach((element) => cleanTextContent(element));
    });

    strikeThroughPriceElements.forEach((element) => {
        observer.observe(element, {
            characterData: true,
            subtree: true,
            childList: true,
        });
    });

    const parentObserver = new MutationObserver(() => {
        document.querySelectorAll(".ctm-strike-through_price").forEach((element) => {
            if (!element._observed) {
                element._observed = true;
                cleanTextContent(element);
                observer.observe(element, {
                    characterData: true,
                    subtree: true,
                    childList: true,
                });
            }
        });
    });

    parentObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });
}



// stopPropagation on .cart__drawer was blocking touchmove/pointermove from
// reaching document, where Swiper v11 registers its move listeners after the
// first touch. Exempt the upsell swiper so Swiper can track horizontal drags.
document.querySelector('.cart__drawer').addEventListener('touchmove', function (event) {
    if (event.target.closest('.upsell-swiper')) return;
    event.stopPropagation();
}, { passive: false });


document.addEventListener("DOMContentLoaded", function () {

  var swiperContainer_nav = document.querySelector(".ctm_nav_upsell_main");

    if (!swiperContainer_nav) return;

    var swiper_nav = new Swiper(swiperContainer_nav, {
      slidesPerView: 2.5, // Default setting
      spaceBetween: 20,
      navigation: {
        nextEl: ".remedy_nav_next",
        prevEl: ".remedy_nav_prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 5.5,
        },
        768: {
          slidesPerView: 3,
        },
        480: {
          slidesPerView: 1,
        },
      },
      on: {
        resize: function () {
          if (swiper_nav) swiper_nav.update(); // Force Swiper to recalculate slides
        },
      },
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const accordionTitles = document.querySelectorAll('.main_ctm_child_link');
  // const elementParent = document.querySelector('#shop-by-steps');

  accordionTitles.forEach((titleEl) => {
    titleEl.addEventListener('click', function () {

      const contentEl = titleEl.nextElementSibling;
      const isOpen = contentEl.classList.contains('open');

      document.querySelectorAll('.main_accordion_content').forEach((panel) => {
        panel.classList.remove('open');
        panel.style.maxHeight = '0px';
      });

      accordionTitles.forEach((el) => el.classList.remove('active'));

      if (!isOpen) {
        contentEl.classList.add('open');
        contentEl.style.maxHeight = contentEl.scrollHeight + 'px';
        titleEl.classList.add('active');
        console.log(`Opened: ${titleEl.textContent.trim()}`);
      } else {
        console.log(`Closed: ${titleEl.textContent.trim()}`);
      }
    });
  });

  /*
  elementParent.addEventListener('click', function (event) {
    if (!event.target.closest('.main_ctm_child_link')) {
      // console.log('Clicked on parent element (not on child)');
      const target = event.currentTarget.querySelectorAll('.main_ctm_child_link');
      if (target.length > 0 && !target[0].classList.contains('active')) {
        target[0].click();
      }
    }
  });
  */

  const handleMenuActive = () => {
    const mobileMenu = document.querySelector("#mobile-ecom-menu");
    if (mobileMenu) {
      const li = mobileMenu.querySelectorAll("li");
      const secondli = mobileMenu.querySelector("#shop-by-steps");
      
      if (li?.length) {
        // The first link is set to active/open by default, the following ones are disabled/closed
        li.forEach((ele, index) => {
          const panel = ele.querySelector(".ac-panel");
          if (index > 0) {
            if (panel) panel.style.height = 0;
            ele.classList.remove("is-active");
            ele.classList.remove("ac--open");
          } else {
            if (panel) panel.style.height = 'auto';
            ele.classList.add("is-active");
            ele.classList.add("ac--open");
          }
        });
      }

      if (secondli) {
        // First childlink is open by default.
        const childLinkHeader = secondli.querySelectorAll('.main_ctm_child_link');
        if (childLinkHeader.length > 0 && !childLinkHeader[0].classList.contains('active')) {
          childLinkHeader[0].click();
        }

        // A css variable is stored in each panel for animation purposes.
        const panels = secondli.querySelectorAll(".main_accordion_content");
        if (panels.length) {
          panels.forEach((panel) => {
            panel.style.setProperty('--ac-content-height', `${panel.scrollHeight}px`);
          });
        }
      }
    } 
  };

  window.addEventListener("load", () => {
    handleMenuActive();
  });

  const hamburger = document.getElementById("hamburger");
  if (hamburger) {
    hamburger.addEventListener("click", () => {
      handleMenuActive();
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const navTab = document.querySelector("nav.header__ecom-menus");

  if (navTab) {
    document.querySelectorAll('a[data-child-menu]').forEach(link => {
      link.addEventListener("mouseenter", function () {
        const menuValue = this.getAttribute("data-child-menu");
        const matchingMenu = document.querySelector(`ul[data-child-menu="${menuValue}"]`);

        document.querySelectorAll('a[data-child-menu]').forEach(otherLink => {
          if (otherLink !== this) {
            otherLink.classList.remove("after:bg-navy");
          }
        });

        this.classList.add("after:bg-navy");

        navTab.classList.remove("invisible");

        if (!matchingMenu) {
          navTab.classList.add("invisible");
        }
      });

      link.addEventListener("mouseleave", function () {
        this.classList.remove("after:bg-navy");
      });
    });
  }
});
// document.addEventListener("DOMContentLoaded", () => {
//     const popup = document.querySelector(".popup-wrap");
//     const overlay = popup?.querySelector(".popup-overlay");
//     const keepShoppingBtn = popup?.querySelector(".cart-popup-keep-shopping");

//     if (!popup) {
//         console.warn("Cart popup not found on page.");
//         return;
//     }

//     // Manual close handlers
//     overlay?.addEventListener("click", () => popup.classList.remove("active"));
//     keepShoppingBtn?.addEventListener("click", () => popup.classList.remove("active"));

//     document.body.addEventListener("click", function(e) {
//         const btn = e.target.closest(".vw--icon-button[data-videowise-variant-id]");
//         if (!btn) return;

//         e.preventDefault();
//         e.stopPropagation();

//         const variantId = btn.getAttribute("data-videowise-variant-id");
//         if (!variantId) {
//             console.warn("Variant ID not found for clicked button.");
//             return;
//         }

//         if (!window.liquidAjaxCart?.add) {
//             console.error("Liquid Ajax Cart is not initialized yet.");
//             return;
//         }

//         // Disable button temporarily
//         if (btn.disabled) return;
//         btn.disabled = true;

//         const formData = new FormData();
//         formData.set("id", variantId);
//         formData.set("quantity", "1");

//         // Add item via Liquid Ajax Cart
//         window.liquidAjaxCart.add(formData, {
//           headers: {
//               'X-Requested-With': 'XMLHttpRequest',
//               'Content-Type': 'application/json'
//             },
//             lastCallback: ({ responseData, requestState }) => {
//                 // Re-enable button
//                 btn.disabled = false;

//                 if (!responseData?.ok) {
//                     console.error("Failed to add item to cart:", responseData);
//                     return;
//                 }

//                 const cart = requestState.responseData.body;

//                 if (!cart?.items || cart.items.length === 0) {
//                     console.warn("Cart is empty after adding item.");
//                     return;
//                 }

//                 const lastItem = cart.items[cart.items.length - 1];

//                 // Update popup immediately with real data
//                 const image = popup.querySelector(".cart-popup-product-image");
//                 const title = popup.querySelector(".cart-popup-product-title");
//                 const options = popup.querySelector(".cart-popup-product-options");
//                 const price = popup.querySelector(".cart-popup-product-price .final-price");
//                 const original = popup.querySelector(".cart-popup-product-price .original-price");
//                 const subtotal = popup.querySelector(".cart-popup-subtotal");
//                 const link = popup.querySelector(".cart-popup-product-link");

//                 if (image) {
//                     image.src = lastItem.image;
//                     image.alt = lastItem.product_title;
//                 }

//                 if (title) title.textContent = lastItem.product_title;
//                 if (link) link.href = lastItem.url;

//                 if (options)
//                     options.textContent =
//                         lastItem.variant_title && lastItem.variant_title !== "Default Title"
//                             ? lastItem.variant_title
//                             : "";

//                 if (price) price.textContent = "PKR " + (lastItem.price / 100).toLocaleString();
//                 if (original)
//                     original.textContent = lastItem.compare_at_price
//                         ? "PKR " + (lastItem.compare_at_price / 100).toLocaleString()
//                         : "";

//                 if (subtotal)
//                     subtotal.textContent = "PKR " + (cart.total_price / 100).toLocaleString();
//             }
//         });
//     }, true);
// });

/* =========================================================
 * CUSTOM CART POPUP
 * ========================================================= */

(function () {
  "use strict";


  /* =======================================================
   * GET POPUP
   * ======================================================= */

  function getPopup() {
    return document.getElementById(
      "cart-popup-notification"
    );
  }


  /* =======================================================
   * CLOSE POPUP
   * ======================================================= */

  function closePopup() {
    const popup = getPopup();

    if (!popup) {
      return false;
    }

    popup.classList.remove("active");

    return false;
  }


  /* =======================================================
   * VIEW CART
   * ======================================================= */

  function viewCart() {
    const popup = getPopup();

    if (!popup) {
      return false;
    }

    popup.classList.remove("active");

    document.body.classList.add(
      "js-show-ajax-cart"
    );

    return false;
  }


  /* =======================================================
   * GET SELLING PLAN GROUPS
   * ======================================================= */

  function getSellingPlanGroups(handle) {
    if (!handle) {
      return Promise.resolve([]);
    }

    return fetch(
      (window.Shopify?.routes?.root || "/") +
        "products/" +
        handle +
        ".js"
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "Unable to load product data"
          );
        }

        return response.json();
      })
      .then(function (product) {
        return (
          product.selling_plan_groups || []
        );
      })
      .catch(function (error) {
        console.error(
          "Cart popup: selling plan error",
          error
        );

        return [];
      });
  }


  /* =======================================================
   * BUILD SUBSCRIPTION TOGGLE
   * ======================================================= */

  function buildSubscriptionToggle(
    item,
    planGroups
  ) {
    if (
      !item ||
      !planGroups ||
      !planGroups.length
    ) {
      return "";
    }

    if (
      !window.liquidAjaxCart ||
      !window.liquidAjaxCart.cart
    ) {
      return "";
    }

    const cartItems =
      window.liquidAjaxCart.cart.items || [];

    const lineIndex =
      cartItems.findIndex(function (cartItem) {
        return cartItem.key === item.key;
      }) + 1;

    if (lineIndex <= 0) {
      return "";
    }

    const firstGroup = planGroups[0];

    if (
      !firstGroup ||
      !firstGroup.selling_plans ||
      !firstGroup.selling_plans.length
    ) {
      return "";
    }

    const currentPlanId =
      item.selling_plan_allocation &&
      item.selling_plan_allocation.selling_plan
        ? item.selling_plan_allocation
            .selling_plan.id
        : null;

    const isSubscribed = !!currentPlanId;

    let selectedPlan = null;

    const options =
      firstGroup.selling_plans
        .map(function (plan, index) {
          if (
            plan.id === currentPlanId ||
            (!currentPlanId && index === 0)
          ) {
            selectedPlan = plan;
          }

          return (
            '<option value="' +
            plan.id +
            '"' +
            (plan.id === currentPlanId
              ? " selected"
              : "") +
            ">" +
            plan.name +
            "</option>"
          );
        })
        .join("");

    const dropdownItems =
      firstGroup.selling_plans
        .map(function (plan) {
          return (
            '<li class="cart__sub-frequency-item' +
            (plan.id === currentPlanId
              ? " active"
              : "") +
            '" data-plan-id="' +
            plan.id +
            '" role="option">' +
            plan.name +
            "</li>"
          );
        })
        .join("");

    const adjustment =
      selectedPlan &&
      selectedPlan.price_adjustments &&
      selectedPlan.price_adjustments.length
        ? selectedPlan.price_adjustments[0]
        : null;

    let discountText = "";

    if (adjustment) {
      if (
        adjustment.value_type ===
        "percentage"
      ) {
        discountText =
          adjustment.value + "%";
      } else if (
        window.Shopify &&
        Shopify.formatMoney
      ) {
        discountText =
          Shopify.formatMoney(
            adjustment.value
          );
      }
    }

    const checkboxId =
      "sub-toggle-popup-" +
      String(item.key).replace(/:/g, "-");

    return (
      '<div class="cart-drawer-ajax-cart">' +

      '<div class="cart__drawer-item-subscription"' +
      ' data-line="' +
      lineIndex +
      '"' +
      ' data-item-key="' +
      item.key +
      '"' +
      ' data-subscribed="' +
      isSubscribed +
      '">' +

      '<label class="cart__sub-toggle" for="' +
      checkboxId +
      '">' +

      '<input' +
      ' type="checkbox"' +
      ' id="' +
      checkboxId +
      '"' +
      ' class="cart__sub-toggle-input"' +
      (isSubscribed
        ? " checked"
        : "") +
      ' aria-label="Subscribe to save ' +
      discountText +
      '"' +
      " />" +

      '<span class="cart__sub-toggle-pill" aria-hidden="true">' +

      '<svg class="x-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">' +
      '<path d="M9 3L3 9M3 3L9 9"' +
      ' stroke="white"' +
      ' stroke-linecap="round"' +
      ' stroke-linejoin="round"/>' +
      "</svg>" +

      '<svg class="check-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">' +
      '<path d="M10 3L4.5 8.5L2 6"' +
      ' stroke="white"' +
      ' stroke-linecap="round"' +
      ' stroke-linejoin="round"/>' +
      "</svg>" +

      "</span>" +

      '<span class="cart__sub-toggle-label cart__sub-toggle-label--active">' +
      "Subscribed. Saving " +
      discountText +
      "</span>" +

      '<span class="cart__sub-toggle-label cart__sub-toggle-label--inactive">' +
      "Subscribe to save " +
      discountText +
      "</span>" +

      "</label>" +

      '<select' +
      ' class="cart__sub-frequency-select"' +
      ' aria-hidden="true"' +
      ' style="display:none;"' +
      ' data-current-plan-id="' +
      (currentPlanId || "") +
      '">' +

      options +

      "</select>" +

      '<div class="cart__sub-frequency-wrap' +
      (isSubscribed
        ? ""
        : " cart__sub-frequency-wrap--hidden") +
      '">' +

      '<div class="cart__sub-frequency-dropdown">' +

      '<button' +
      ' class="cart__sub-frequency-trigger"' +
      ' type="button"' +
      ' aria-expanded="false"' +
      ' aria-label="Select delivery frequency">' +

      '<span class="cart__sub-frequency-text">' +
      (selectedPlan
        ? selectedPlan.name
        : "Select frequency") +
      "</span>" +

      '<span class="cart__sub-frequency-arrow" aria-hidden="true">' +

      '<svg width="10" height="6" viewBox="0 0 10 6" fill="none">' +
      '<path d="M1 1L5 5L9 1"' +
      ' stroke="currentColor"' +
      ' stroke-width="2"' +
      ' stroke-linecap="round"' +
      ' stroke-linejoin="round"/>' +
      "</svg>" +

      "</span>" +

      "</button>" +

      '<ul class="cart__sub-frequency-list" role="listbox">' +

      dropdownItems +

      "</ul>" +

      "</div>" +

      "</div>" +

      "</div>" +

      "</div>"
    );
  }


  /* =======================================================
   * FORMAT MONEY
   * ======================================================= */

  function formatPopupMoney(value) {
    const currency =
      document.body.getAttribute(
        "data-currency-symbol"
      ) || "$";

    if (
      window.Shopify &&
      Shopify.formatMoney
    ) {
      return Shopify.formatMoney(value)
        .replace("$", currency);
    }

    return (
      currency +
      (
        Number(value || 0) / 100
      ).toFixed(2)
    );
  }


  /* =======================================================
   * SAFE HTML ESCAPE
   * ======================================================= */

  function escapeHtml(value) {
    const div = document.createElement("div");

    div.textContent =
      value == null ? "" : String(value);

    return div.innerHTML;
  }


  /* =======================================================
   * GET CART PRODUCT METAFIELD MAP
   *
   * Reads:
   *
   * <script type="application/json"
   *         id="cart-product-metafields">
   *
   * {
   *   "product-handle": "Custom Title"
   * }
   *
   * This is the reliable method being used now.
   * ======================================================= */

  function getCartProductMetafieldMap() {
    const script =
      document.getElementById(
        "cart-product-metafields"
      );

    if (!script) {
      console.warn(
        "Cart popup: #cart-product-metafields not found."
      );

      return {};
    }

    try {
      const data =
        JSON.parse(
          script.textContent || "{}"
        );

      if (
        !data ||
        typeof data !== "object"
      ) {
        return {};
      }

      return data;
    } catch (error) {
      console.error(
        "Cart popup: unable to parse #cart-product-metafields JSON.",
        error
      );

      return {};
    }
  }


  /* =======================================================
   * GET CART PRODUCT METAFIELD TITLE
   *
   * Uses productInfo.handle to find:
   *
   * custom.cart_product_title
   *
   * Example:
   *
   * handle:
   * dark-circle-reducing-advanced-eye-cream
   *
   * returns:
   * Dark Circle Reducing Eye Cream
   * ======================================================= */

  function getCartProductMetafieldTitle(
    productInfo
  ) {
    if (
      !productInfo ||
      !productInfo.handle
    ) {
      return "";
    }

    const metafieldMap =
      getCartProductMetafieldMap();

    if (!metafieldMap) {
      return "";
    }

    const handle =
      String(
        productInfo.handle
      ).trim();

    if (!handle) {
      return "";
    }

    const value =
      metafieldMap[handle];

    if (
      value === undefined ||
      value === null
    ) {
      return "";
    }

    const title =
      String(value).trim();

    return title;
  }


  /* =======================================================
   * GET CART TITLE FROM PROPERTIES
   * ======================================================= */

  function getCartTitleFromProperties(productInfo) {
    if (!productInfo) {
      return "";
    }

    const properties =
      productInfo.properties || {};

    const possibleKeys = [
      "_cart_product_title",
      "Cart Product Title",
      "cart_product_title",
      "cart-product-title",
      "Cart_Product_Title",
    ];

    for (let i = 0; i < possibleKeys.length; i++) {
      const key = possibleKeys[i];

      if (
        properties[key] !== undefined &&
        properties[key] !== null &&
        String(properties[key]).trim() !== ""
      ) {
        return String(
          properties[key]
        ).trim();
      }
    }

    const propertyKeys =
      Object.keys(properties);

    for (
      let i = 0;
      i < propertyKeys.length;
      i++
    ) {
      const key = propertyKeys[i];

      const normalized =
        String(key)
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "");

      if (
        normalized.indexOf("cart") !== -1 &&
        normalized.indexOf("title") !== -1 &&
        properties[key]
      ) {
        return String(
          properties[key]
        ).trim();
      }
    }

    return "";
  }


  /* =======================================================
   * GET FINAL CART PRODUCT TITLE
   *
   * PRIORITY:
   *
   * 1. custom.cart_product_title
   * 2. line item cart title property
   * 3. Purpose property
   * 4. normal product title
   *
   * The metafield is now retrieved from the JSON map.
   * ======================================================= */

  function getFinalCartProductTitle(
    productInfo
  ) {
    if (!productInfo) {
      return "";
    }


    /* =====================================================
     * 1. CUSTOM METAFIELD
     * ===================================================== */

    const metafieldTitle =
      getCartProductMetafieldTitle(
        productInfo
      );

    if (metafieldTitle) {
      return metafieldTitle;
    }


    /* =====================================================
     * 2. LINE ITEM PROPERTY
     * ===================================================== */

    const propertyTitle =
      getCartTitleFromProperties(
        productInfo
      );

    if (propertyTitle) {
      return propertyTitle;
    }


    /* =====================================================
     * 3. PURPOSE PROPERTY
     * ===================================================== */

    const properties =
      productInfo.properties || {};

    if (
      properties.Purpose &&
      String(properties.Purpose).trim()
    ) {
      return String(
        properties.Purpose
      ).trim();
    }


    /* =====================================================
     * 4. NORMAL PRODUCT TITLE
     * ===================================================== */

    let title =
      productInfo.product_title ||
      productInfo.title ||
      "";

    title = String(title)
      .replace(
        /^(Remedy\s+for\s+|for\s+)/i,
        ""
      )
      .trim();

    return title;
  }


  /* =======================================================
   * UPDATE POPUP PRODUCT TITLE
   *
   * IMPORTANT:
   *
   * This function does NOT depend on a metafield being
   * available inside the AJAX cart response.
   *
   * It gets the product handle from the cart item and then
   * looks up the title in #cart-product-metafields.
   * ======================================================= */

  function updatePopupProductTitle(
    productInfo,
    titleElement
  ) {
    if (!titleElement) {
      return;
    }

    const finalTitle =
      getFinalCartProductTitle(
        productInfo
      );

    if (!finalTitle) {
      return;
    }


    /* =====================================================
     * CHECK WHETHER THIS IS A CUSTOM METAFIELD TITLE
     * ===================================================== */

    const metafieldTitle =
      getCartProductMetafieldTitle(
        productInfo
      );


    /*
     * If custom.cart_product_title exists,
     * show ONLY that title.
     *
     * This matches your cart drawer logic:
     *
     * {% if item.product.metafields.custom.cart_product_title != blank %}
     *   {{ item.product.metafields.custom.cart_product_title }}
     * {% endif %}
     */

    if (metafieldTitle) {
      titleElement.textContent =
        metafieldTitle;

      return;
    }


    /* =====================================================
     * CART LINE ITEM PROPERTY
     * ===================================================== */

    const properties =
      productInfo &&
      productInfo.properties
        ? productInfo.properties
        : {};

    const cartTitleProp =
      properties._cart_product_title ||
      properties["Cart Product Title"] ||
      properties["cart_product_title"] ||
      properties["cart-product-title"] ||
      properties["Cart_Product_Title"];

    if (
      cartTitleProp &&
      String(cartTitleProp).trim() !== ""
    ) {
      titleElement.textContent =
        String(cartTitleProp).trim();

      return;
    }


    /* =====================================================
     * PURPOSE PROPERTY
     * ===================================================== */

    if (
      properties.Purpose &&
      String(properties.Purpose).trim() !== ""
    ) {
      titleElement.innerHTML =
        '<span class="heading-24 md:text-20">Remedy</span>' +
        '<span class="text-script text-32 mx-1.5 ml-2 relative top-0.5 md:text-22 md_min:ml-3">for</span>' +
        "<span>" +
        escapeHtml(
          String(properties.Purpose).trim()
        ) +
        "</span>";

      return;
    }


    /* =====================================================
     * NORMAL PRODUCT TITLE
     * ===================================================== */

    let productTitle =
      productInfo &&
      (
        productInfo.product_title ||
        productInfo.title ||
        ""
      );

    productTitle = String(productTitle)
      .replace(
        /^(Remedy for |for )/i,
        ""
      )
      .trim();

    if (!productTitle) {
      return;
    }

    titleElement.innerHTML =
      '<span class="heading-24 md:text-20">Remedy</span>' +
      '<span class="text-script text-32 mx-1.5 ml-2 relative top-0.5 md:text-22 md_min:ml-3">for</span>' +
      "<span>" +
      escapeHtml(productTitle) +
      "</span>";
  }


  /* =======================================================
   * UPDATE POPUP PRICE
   * ======================================================= */

  function updatePopupPrice() {
    const popup = getPopup();

    if (!popup) {
      return;
    }

    if (
      !window.liquidAjaxCart ||
      !window.liquidAjaxCart.cart
    ) {
      return;
    }

    const container =
      popup.querySelector(
        ".cart-popup-container"
      );

    if (!container) {
      return;
    }

    const currentKey =
      container.getAttribute(
        "data-current-item-key"
      );

    const variantId =
      Number(
        container.getAttribute(
          "data-current-variant-id"
        )
      );

    const cartItems =
      window.liquidAjaxCart.cart.items ||
      [];

    let item = currentKey
      ? cartItems.find(function (cartItem) {
          return (
            cartItem.key === currentKey
          );
        })
      : null;

    if (!item && variantId) {
      item = cartItems.find(
        function (cartItem) {
          return (
            Number(
              cartItem.variant_id
            ) === variantId
          );
        }
      );
    }

    if (!item) {
      return;
    }


    /* PRICE */

    const finalPrice =
      popup.querySelector(
        ".final-price"
      );

    const originalPrice =
      popup.querySelector(
        ".original-price"
      );

    const subtotal =
      popup.querySelector(
        ".cart-popup-subtotal"
      );

    if (finalPrice) {
      finalPrice.textContent =
        Number(
          item.final_line_price
        ) === 0
          ? "FREE"
          : formatPopupMoney(
              item.final_line_price
            );
    }

    if (originalPrice) {
      if (
        Number(
          item.original_line_price
        ) >
        Number(
          item.final_line_price
        )
      ) {
        originalPrice.textContent =
          formatPopupMoney(
            item.original_line_price
          );

        originalPrice.style.display =
          "inline";
      } else {
        originalPrice.textContent = "";

        originalPrice.style.display =
          "none";
      }
    }

    if (subtotal) {
      subtotal.textContent =
        formatPopupMoney(
          window.liquidAjaxCart.cart
            .total_price
        );
    }


    /* UPDATE TITLE */

    const title =
      popup.querySelector(
        ".cart-popup-product-title"
      );

    if (title && item) {
      updatePopupProductTitle(
        item,
        title
      );
    }
  }


  /* =======================================================
   * SHOW CART POPUP
   * ======================================================= */

  function showCartPopup(requestState) {
    if (!requestState) {
      return;
    }

    if (
      requestState.requestType !== "add"
    ) {
      return;
    }

    if (
      !requestState.responseData ||
      !requestState.responseData.ok
    ) {
      return;
    }

    if (
      document.querySelector(
        "body.js-show-ajax-cart"
      )
    ) {
      return;
    }

    const productInfo =
      requestState.responseData.body;

    if (!productInfo) {
      return;
    }

    const extraResponseData =
      requestState.extraResponseData;

    const subtotalPrice =
      extraResponseData &&
      extraResponseData.body
        ? extraResponseData.body
            .items_subtotal_price
        : null;

    const popup = getPopup();

    if (!popup) {
      return;
    }

    const container =
      popup.querySelector(
        ".cart-popup-container"
      );

    if (!container) {
      return;
    }


    /* SAVE CURRENT ITEM */

    container.setAttribute(
      "data-current-item-key",
      productInfo.key || ""
    );

    container.setAttribute(
      "data-current-variant-id",
      productInfo.variant_id || ""
    );


    /* IMAGE */

    const image =
      container.querySelector(
        ".cart-popup-product-image"
      );

    if (image) {
      let imageUrl = "";

      if (
        productInfo.properties &&
        productInfo.properties
          ._ThumbnailSimple
      ) {
        imageUrl =
          productInfo.properties
            ._ThumbnailSimple.replace(
              /(\.[^.]*)$/,
              "_400x400$1"
            );

        image.alt = "";
      } else if (
        productInfo.properties &&
        productInfo.properties
          ._Thumbnail
      ) {
        imageUrl =
          productInfo.properties
            ._Thumbnail.replace(
              /(\.[^.]*)$/,
              "_400x400$1"
            );

        image.alt = "";
      } else if (
        productInfo.featured_image &&
        productInfo.featured_image.url
      ) {
        imageUrl =
          productInfo.featured_image.url.replace(
            /(\.[^.]*)$/,
            "_400x400$1"
          );

        image.alt =
          productInfo.featured_image.alt ||
          "";
      }

      if (imageUrl) {
        image.src = imageUrl;
      }
    }


    /* PRODUCT LINK */

    const link =
      container.querySelector(
        ".cart-popup-product-link"
      );

    if (
      link &&
      productInfo.url
    ) {
      link.href =
        productInfo.url;
    }


    /* =====================================================
     * PRODUCT TITLE
     * ===================================================== */

    const title =
      container.querySelector(
        ".cart-popup-product-title"
      );

    if (title) {
      updatePopupProductTitle(
        productInfo,
        title
      );
    }


    /* OPTIONS */

    const options =
      container.querySelector(
        ".cart-popup-product-options"
      );

    if (options) {
      if (
        !productInfo
          .product_has_only_default_variant &&
        productInfo.options_with_values &&
        productInfo.options_with_values.length
      ) {
        options.innerHTML =
          productInfo.options_with_values
            .map(function (option) {
              return (
                '<p class="text-18 font-heading md:text-14">' +
                escapeHtml(
                  option.value
                ) +
                "</p>"
              );
            })
            .join("");
      } else {
        options.innerHTML = "";
      }
    }


    /* SELLING PLAN */

    const sellingPlanContainer =
      container.querySelector(
        ".cart-popup-product-selling-plan"
      );

    if (sellingPlanContainer) {
      sellingPlanContainer.innerHTML = "";

      if (productInfo.handle) {
        getSellingPlanGroups(
          productInfo.handle
        ).then(function (groups) {
          if (
            !sellingPlanContainer.isConnected
          ) {
            return;
          }

          sellingPlanContainer.innerHTML =
            buildSubscriptionToggle(
              productInfo,
              groups
            );
        });
      }
    }


    /* FINAL PRICE */

    const finalPrice =
      container.querySelector(
        ".final-price"
      );

    if (finalPrice) {
      finalPrice.textContent =
        Number(
          productInfo.final_line_price
        ) === 0
          ? "FREE"
          : formatPopupMoney(
              productInfo.final_line_price
            );
    }


    /* ORIGINAL PRICE */

    const originalPrice =
      container.querySelector(
        ".original-price"
      );

    if (originalPrice) {
      if (
        Number(
          productInfo.final_line_price
        ) === 0 ||
        Number(
          productInfo.total_discount
        ) === 0
      ) {
        originalPrice.textContent = "";

        originalPrice.style.display =
          "none";
      } else {
        originalPrice.textContent =
          formatPopupMoney(
            productInfo.original_line_price
          );

        originalPrice.style.display =
          "inline";
      }
    }


    /* CART SUBTOTAL */

    const subtotal =
      container.querySelector(
        ".cart-popup-subtotal"
      );

    if (
      subtotal &&
      subtotalPrice !== null &&
      subtotalPrice !== undefined
    ) {
      subtotal.textContent =
        formatPopupMoney(
          subtotalPrice
        );
    }


    /* GAMIFICATION */

    const gamification =
      document.querySelector(
        ".cart-gamification-js"
      );

    const gamificationPopup =
      document.querySelector(
        ".cart-gamification-popup-js"
      );

    if (
      gamification &&
      gamificationPopup
    ) {
      gamificationPopup.innerHTML =
        gamification.innerHTML;
    }


    /* OPEN POPUP */

    popup.classList.add("active");


    /* =====================================================
     * TITLE REFRESH
     *
     * Some theme scripts may update/re-render the popup.
     * Refresh the title after rendering.
     * ===================================================== */

    requestAnimationFrame(function () {
      const currentTitle =
        popup.querySelector(
          ".cart-popup-product-title"
        );

      if (currentTitle) {
        updatePopupProductTitle(
          productInfo,
          currentTitle
        );
      }
    });


    setTimeout(function () {
      const currentTitle =
        popup.querySelector(
          ".cart-popup-product-title"
        );

      if (currentTitle) {
        updatePopupProductTitle(
          productInfo,
          currentTitle
        );
      }
    }, 250);


    setTimeout(function () {
      const currentTitle =
        popup.querySelector(
          ".cart-popup-product-title"
        );

      if (currentTitle) {
        updatePopupProductTitle(
          productInfo,
          currentTitle
        );
      }
    }, 700);


    bindPopupButtons();
  }


  /* =======================================================
   * POPUP BUTTON EVENTS
   * ======================================================= */

  function bindPopupButtons() {
    document
      .querySelectorAll(
        ".cart-popup-keep-shopping"
      )
      .forEach(function (element) {
        if (
          element.dataset.popupBound ===
          "true"
        ) {
          return;
        }

        element.dataset.popupBound = "true";

        element.addEventListener(
          "click",
          closePopup
        );
      });


    const viewCartButton =
      document.querySelector(
        ".cart-popup-view-cart"
      );

    if (
      viewCartButton &&
      viewCartButton.dataset.popupBound !==
        "true"
    ) {
      viewCartButton.dataset.popupBound =
        "true";

      viewCartButton.addEventListener(
        "click",
        viewCart
      );
    }
  }


  /* =======================================================
   * LIQUID AJAX CART ADD EVENT
   * ======================================================= */

  document.addEventListener(
    "liquid-ajax-cart:request-end",
    function (event) {
      const requestState =
        event.detail &&
        event.detail.requestState;

      if (!requestState) {
        return;
      }

      showCartPopup(requestState);
    }
  );


  /* =======================================================
   * LIQUID AJAX CART INTERNAL EVENT
   * ======================================================= */

  document.addEventListener(
    "liquid-ajax-cart:request-end-internal",
    function (event) {
      const requestState =
        event.detail &&
        event.detail.requestState;

      if (!requestState) {
        return;
      }

      if (
        requestState.requestType !==
          "change" &&
        requestState.requestType !==
          "add"
      ) {
        return;
      }


      /* WAIT FOR CART UPDATE */

      setTimeout(function () {
        const popup = getPopup();

        if (
          popup &&
          popup.classList.contains(
            "active"
          )
        ) {
          updatePopupPrice();
        }
      }, 300);


      /* ADDITIONAL TITLE REFRESH */

      if (
        requestState.requestType ===
          "add" &&
        requestState.responseData &&
        requestState.responseData.ok
      ) {
        const productInfo =
          requestState.responseData.body;

        if (productInfo) {
          setTimeout(function () {
            const popup = getPopup();

            if (!popup) {
              return;
            }

            const title =
              popup.querySelector(
                ".cart-popup-product-title"
              );

            if (title) {
              updatePopupProductTitle(
                productInfo,
                title
              );
            }
          }, 500);
        }
      }
    }
  );


  /* =======================================================
   * INITIAL BUTTON BIND
   * ======================================================= */

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      bindPopupButtons
    );
  } else {
    bindPopupButtons();
  }


  /* =======================================================
   * VIDEOWISE ADD TO CART
   * ======================================================= */

  document.addEventListener(
    "DOMContentLoaded",
    function () {
      const popup =
        document.querySelector(
          ".popup-wrap"
        );

      if (!popup) {
        console.warn(
          "Cart popup not found on page."
        );

        return;
      }

      const overlay =
        popup.querySelector(
          ".popup-overlay"
        );

      const keepShoppingBtn =
        popup.querySelector(
          ".cart-popup-keep-shopping"
        );


      overlay?.addEventListener(
        "click",
        () => {
          popup.classList.remove(
            "active"
          );
        }
      );


      keepShoppingBtn?.addEventListener(
        "click",
        () => {
          popup.classList.remove(
            "active"
          );
        }
      );


      document.body.addEventListener(
        "click",
        function (e) {
          const btn =
            e.target.closest(
              ".vw--icon-button[data-videowise-variant-id]"
            );

          if (!btn) {
            return;
          }

          e.preventDefault();
          e.stopPropagation();

          const variantId =
            btn.getAttribute(
              "data-videowise-variant-id"
            );

          if (!variantId) {
            console.warn(
              "Variant ID not found for clicked button."
            );

            return;
          }

          if (
            !window.liquidAjaxCart?.add
          ) {
            console.error(
              "Liquid Ajax Cart is not initialized yet."
            );

            return;
          }

          if (btn.disabled) {
            return;
          }

          btn.disabled = true;

          const formData =
            new FormData();

          formData.set(
            "id",
            variantId
          );

          formData.set(
            "quantity",
            "1"
          );


          window.liquidAjaxCart.add(
            formData,
            {
              headers: {
                "X-Requested-With":
                  "XMLHttpRequest",

                "Content-Type":
                  "application/json",
              },

              lastCallback:
                ({
                  responseData,
                  requestState,
                }) => {
                  btn.disabled = false;

                  if (
                    !responseData?.ok
                  ) {
                    console.error(
                      "Failed to add item to cart:",
                      responseData
                    );

                    return;
                  }


                  const cart =
                    requestState
                      ?.responseData
                      ?.body;

                  if (
                    !cart?.items ||
                    cart.items.length ===
                      0
                  ) {
                    console.warn(
                      "Cart is empty after adding item."
                    );

                    return;
                  }


                  const lastItem =
                    cart.items[
                      cart.items.length - 1
                    ];


                  console.log(
                    "CUSTOM VIDEOWISE CART PRODUCT:",
                    lastItem
                  );


                  /* IMAGE */

                  const image =
                    popup.querySelector(
                      ".cart-popup-product-image"
                    );

                  const options =
                    popup.querySelector(
                      ".cart-popup-product-options"
                    );

                  const price =
                    popup.querySelector(
                      ".cart-popup-product-price .final-price"
                    );

                  const original =
                    popup.querySelector(
                      ".cart-popup-product-price .original-price"
                    );

                  const subtotal =
                    popup.querySelector(
                      ".cart-popup-subtotal"
                    );

                  const link =
                    popup.querySelector(
                      ".cart-popup-product-link"
                    );


                  if (image) {
                    image.src =
                      lastItem.image ||
                      "";

                    image.alt =
                      lastItem.product_title ||
                      "";
                  }


                  /* =================================================
                   * TITLE
                   *
                   * IMPORTANT:
                   *
                   * lastItem.handle is used to retrieve the
                   * custom.cart_product_title from JSON.
                   * ================================================= */

                  const title =
                    popup.querySelector(
                      ".cart-popup-product-title"
                    );

                  if (title) {
                    updatePopupProductTitle(
                      lastItem,
                      title
                    );
                  }


                  if (link) {
                    link.href =
                      lastItem.url || "";
                  }


                  if (options) {
                    options.textContent =
                      lastItem.variant_title &&
                      lastItem.variant_title !==
                        "Default Title"
                        ? lastItem.variant_title
                        : "";
                  }


                  if (price) {
                    price.textContent =
                      Number(
                        lastItem.final_line_price ??
                          lastItem.price ??
                          0
                      ) === 0
                        ? "FREE"
                        : formatPopupMoney(
                            lastItem.final_line_price ??
                              lastItem.price ??
                              0
                          );
                  }


                  if (original) {
                    if (
                      Number(
                        lastItem.original_line_price ||
                          lastItem.compare_at_price ||
                          0
                      ) >
                      Number(
                        lastItem.final_line_price ||
                          lastItem.price ||
                          0
                      )
                    ) {
                      original.textContent =
                        formatPopupMoney(
                          lastItem.original_line_price ||
                            lastItem.compare_at_price
                        );

                      original.style.display =
                        "inline";
                    } else {
                      original.textContent =
                        "";

                      original.style.display =
                        "none";
                    }
                  }


                  if (subtotal) {
                    subtotal.textContent =
                      formatPopupMoney(
                        cart.total_price ||
                          0
                      );
                  }


                  /* SAVE CURRENT ITEM */

                  const container =
                    popup.querySelector(
                      ".cart-popup-container"
                    );

                  if (container) {
                    container.setAttribute(
                      "data-current-item-key",
                      lastItem.key || ""
                    );

                    container.setAttribute(
                      "data-current-variant-id",
                      lastItem.variant_id || ""
                    );
                  }


                  /* =================================================
                   * TITLE REFRESH
                   * ================================================= */

                  setTimeout(function () {
                    const currentTitle =
                      popup.querySelector(
                        ".cart-popup-product-title"
                      );

                    if (currentTitle) {
                      updatePopupProductTitle(
                        lastItem,
                        currentTitle
                      );
                    }
                  }, 300);


                  /* SHOW POPUP */

                  popup.classList.add(
                    "active"
                  );
                },
            }
          );
        },
        true
      );
    }
  );

})();